/**
 * 主行动区
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import WarrancyWidget from 'src/common/warrancy-widget';
import AfterWidget from 'src/common/aftersale-widget';
import { getText } from 'src/utils/i18n';
import LeadtimeTable from '../product-leadtime-table';
import MaApplication from './application';
import MaShipping from './shipping';
import SpuTips from './spu-tips';
import BuySample from '../buy-sample';
import TaModule from '../ta';
import Payment from '../payments';
import TaServices from '../ta-services';
import DealCustomize from '../deal-customize';
import Warehouse from './warehouse';
import SeaFreight from './sea-freight';

import './index.scss';

export default class DetailMainAction extends PureComponent {
  static propTypes = {
    ipCountry: PropTypes.string,
    i18n: PropTypes.object,
    language: PropTypes.string,
    product: PropTypes.object,
    seller: PropTypes.object,
    industry: PropTypes.object,
    extend: PropTypes.object,
    trade: PropTypes.object,
    productLogisticsMode: PropTypes.arrayOf(PropTypes.string),
  };

  render() {
    const {
      ipCountry,
      i18n,
      language,
      product = {},
      seller = {},
      extend = {},
      industry,
      trade = {},
      visitCountry,
      productLogisticsMode,
    } = this.props;

    const {
      hasSPU,
      spu,
      productId,
      supplyChainService,
      morePaymentTerms,
      applicationProperty,
      productIsMarketGoods,
      productIsHang,
      sample,
      sku = {},
      lightCustomModel,
      customModel,
      productEncryptId,
      productLightCustomizationList,
      price = {},
    } = product;
    const {
      companyRegisterCountry,
      baoAccountIsDisplayAssurance,
      baoAccountIsService,
      companyId,
    } = seller;
    const { logisticInfo = {}, leadTimeInfo = {}, tradeInfo = {} } = trade;
    const { productShippingTemplateId } = logisticInfo;
    const { warranty, coreCompWarranty, coreInstruction, afterSaleTemplateId } =
      industry || {};
    const { cspuCount } = spu || {};
    const { detailEncryptId } = extend;

    const {
      productSamplingOrderQuantity,
      productSamplingPrice,
      priceUnit,
      productSamplingType,
    } = sample || {};
    const { skuSample, skuAttrs, skuSampleFirstFormatPrice } = sku;
    const { ladderPeriodList } = leadTimeInfo;
    const { quantityUnitStr } = tradeInfo;

    return (
      <div className="module-market-action detail-mainscreen-center-grid">
        {/* 质保 */}
        {industry ? (
          <WarrancyWidget
            scene="detail"
            total={warranty}
            core={coreCompWarranty}
            coreInstruction={coreInstruction}
            ddClassName="market-action-list__dd"
            dtClassName="market-action-list__dt"
            pid={productId}
            i18n={{
              warrancy: getText(i18n, 'industry.warrancy', 'Warranty:'),
              total: getText(
                i18n,
                'industry.warrancy.total',
                'for machinery warranty',
              ),
              core: getText(
                i18n,
                'industry.warrancy.core',
                'for Core Components',
              ),
              text: getText(
                i18n,
                'industry.warrancy.text',
                'Core Components include ',
              ),
            }}
          />
        ) : null}
        {/* 样品 */}
        {sample ? (
          <BuySample
            productIsMarketGoods={productIsMarketGoods}
            productId={productId}
            i18n={i18n}
            detailEncryptId={detailEncryptId}
            productShippingTemplateId={productShippingTemplateId}
            productIsHang={productIsHang}
            productSamplingOrderQuantity={productSamplingOrderQuantity}
            productSamplingPrice={productSamplingPrice}
            price={price}
            priceUnit={priceUnit}
            skuSampleFirstFormatPrice={skuSampleFirstFormatPrice}
            productSamplingType={productSamplingType}
            companyId={companyId}
            skuAttrs={skuAttrs}
            industry={industry}
            visitCountry={visitCountry}
            skuSample={skuSample}
          />
        ) : null}

        {/* 物流选择 */}
        <Warehouse
          style={{
            marginBottom: 2,
          }}
        />

        {/* leadtime表格 */}
        <LeadtimeTable
          ladderPeriodList={ladderPeriodList}
          i18n={i18n}
          productIsMarketGoods={productIsMarketGoods}
          quantityUnitStr={quantityUnitStr}
        />

        {/* 定制 */}
        <DealCustomize
          lightCustomModel={lightCustomModel}
          customModel={customModel}
          productId={productId}
          companyId={companyId}
          productEncryptId={productEncryptId}
          productLightCustomizationList={productLightCustomizationList}
          price={price}
        />

        {hasSPU ? (
          <MaApplication applicationProperty={applicationProperty} />
        ) : null}
        {/* spu提示 */}
        {spu ? (
          <SpuTips hasSPU={hasSPU} i18n={i18n} cspuCount={cspuCount} />
        ) : null}
        <MaShipping i18n={i18n} productLogisticsMode={productLogisticsMode} />
        {/* 售后 */}
        {industry && afterSaleTemplateId ? (
          <AfterWidget
            defaultCountry={ipCountry}
            showSplitLine
            ddClassName="market-action-list__dd"
            dtClassName="market-action-list__dt"
            i18n={{
              aftersale: getText(i18n, 'industry.aftersale', 'After-sales:'),
              aftersaleBalloonTitle: getText(
                i18n,
                'industry.aftersale.aftersaleBalloonTitle',
                'Local After-sales',
              ),
              aftersalseBalloonText: getText(
                i18n,
                'industry.aftersale.aftersalseBalloonText',
                'Select country/region ',
              ),
            }}
            pid={productId}
            lang={language}
            tempId={afterSaleTemplateId}
          />
        ) : null}

        <div
          style={{
            fontSize: 12,
          }}
        >
          {/* ta */}
          <TaModule
            i18n={i18n}
            baoAccountIsDisplayAssurance={baoAccountIsDisplayAssurance}
          />

          {/* 询盘品询价入口 */}
          <SeaFreight
            productIsMarketGoods={productIsMarketGoods}
            ipCountry={ipCountry}
          />

          {/* payment */}
          <Payment
            morePaymentTerms={morePaymentTerms}
            i18n={i18n}
            companyRegisterCountry={companyRegisterCountry}
            baoAccountIsService={baoAccountIsService}
          />
          {/* services */}
          <TaServices
            productId={productId}
            i18n={i18n}
            companyRegisterCountry={companyRegisterCountry}
            supplyChainService={supplyChainService}
            baoAccountIsDisplayAssurance={baoAccountIsDisplayAssurance}
          />
        </div>
      </div>
    );
  }
}
